import { render, staticRenderFns } from "./DeviceRow.vue?vue&type=template&id=4ce83aee&scoped=true"
import script from "./DeviceRow.vue?vue&type=script&lang=js"
export * from "./DeviceRow.vue?vue&type=script&lang=js"
import style0 from "./DeviceRow.vue?vue&type=style&index=0&id=4ce83aee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../4rahgit/GPS-Tracking-Client-Panel/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ce83aee",
  null
  
)

export default component.exports